import React, { useState } from 'react';
import ModalComissaoProdutosVendedor from '../ModalComissaoProdutosVendedor';
import 'rc-slider/assets/index.css';
import { post } from '../../services/api'
import { ThreeDots } from "react-loader-spinner";

function DetalheProgressoUsuario({ dadosAnimal }) {

    const [isModalComissaoVendedorOpen, setIsModalComissaoVendedorOpen] = useState(false);
    const [dadosComissaoVendedor, setDadosComissaoVendedor] = useState(null);
    const [top10ProdutosComissao, setTop10ProdutosComissao] = useState(null);
    const [isFetchingDataComissaoProdutosVendedor, setIsFetchingDataComissaoProdutosVendedor] = useState(false);

    const handleOpenModal = (item) => {
        getTop10Produtos(item);
    };

    const handleCloseModal = () => {
        document.body.classList.remove('overflow-hidden');
        setIsModalComissaoVendedorOpen(false);
        setDadosComissaoVendedor(null);
        setTop10ProdutosComissao(null);
    };

    async function getTop10Produtos(item) {
        try {
            const [mes, ano] = dadosAnimal.mesAno.split('-');

            setIsFetchingDataComissaoProdutosVendedor(true);

            const requisicao = { mes: mes, ano: ano, departamento: item.iddepartamento };
            const response = await post('/leao/top10produtos', requisicao);

            setIsFetchingDataComissaoProdutosVendedor(false);

            setTop10ProdutosComissao(response);
            setDadosComissaoVendedor(item);
            setIsModalComissaoVendedorOpen(true);
            document.body.classList.add('overflow-hidden');

        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    function formatoMoeda(value) {
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
    }

    function formatarValor(valor) {
        try {
            const valort = parseFloat(valor);

            if (dadosAnimal.formatacao.valores === 'quantidade') {
                return parseInt(valort);
            }

            if (dadosAnimal.formatacao.valores === 'percentual') {
                return `${(parseFloat(valort)).toFixed(2).replace('.', ',')}%`;
            }

            if (dadosAnimal.formatacao.valores === 'moeda') {
                return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valort);
            }
        } catch (error) {
            console.error('Erro: ' + error.message);
        }
    }

    function mesAtual() {
        const meses = [
            'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
            'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
        ];

        const [mes, ano] = dadosAnimal.mesAno.split('-');
        const mesAtual = mes - 1;
        const anoAtual = ano;

        return `${meses[mesAtual]} de ${anoAtual}`;
    }

    function getClasseColunaRegional(valor, meta) {
        if (parseFloat(valor) < parseFloat(meta)) {
            return 'text-red-c1';
        }

        return 'text-green-c1';

    }

    const renderLeaoTable = () => {
        return (
            <>
                <div className="table-wrapper">
                    <table className="table-progresso">
                        <thead>
                            <tr>
                                <th className="coluna-departamento">Departamento</th>
                                <th>Ano Ant</th>
                                <th>Realizado</th>
                                <th>Ano Ant</th>
                                <th>Ano Atual</th>
                                <th>Participação</th>
                                <th>Projetado</th>
                                {dadosAnimal.dados[0].somaprojecaocomissao > 0 && <th>Projeção Comissão</th>}
                                {dadosAnimal.dados[0].somaprojecaocomissao > 0 && <th>Dicas</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {dadosAnimal.dados.map((item, index) => (
                                <tr key={index}>
                                    <td className="coluna-departamento">{item.agrupador}</td>
                                    <td>{item.quantidadepassado}</td>
                                    <td>{item.quantidade}</td>
                                    <td>{formatoMoeda(item.totalpresentepassado)}</td>
                                    <td>{formatoMoeda(item.totalpresente)}</td>
                                    <td>{item.participacao.replace('.', ',')}%</td>
                                    <td>{formatoMoeda(item.projecao)}</td>
                                    {dadosAnimal.dados[0].somaprojecaocomissao > 0 && <td>{formatoMoeda(item.projecaocomissao)}</td>}

                                    {dadosAnimal.dados[0].somaprojecaocomissao > 0 &&
                                        <td>
                                            <button className="text-blue-c1" onClick={() => handleOpenModal(item)}>
                                                {!isFetchingDataComissaoProdutosVendedor ? (
                                                    <span>Aumente suas vendas &rarr;</span>
                                                ) :
                                                    (
                                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                            <ThreeDots
                                                                height="10"
                                                                width="175"
                                                                radius="9"
                                                                color="#4a8ff7"
                                                                ariaLabel="three-dots-loading"
                                                                wrapperStyle={{}}
                                                                wrapperClassName=""
                                                                visible={true}
                                                            />
                                                        </div>
                                                    )}
                                            </button>
                                        </td>
                                    }
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td className="coluna-departamento">Total</td>
                                <td>{dadosAnimal.dados[0].somaquantidadepassado}</td>
                                <td>{dadosAnimal.dados[0].somaquantidade}</td>
                                <td>{formatoMoeda(dadosAnimal.dados[0].somatotalpresentepassado)}</td>
                                <td>{formatoMoeda(dadosAnimal.dados[0].somatotalpresente)}</td>
                                <td>100%</td>
                                <td>{formatoMoeda(dadosAnimal.dados[0].somaprojecao)}</td>
                                {dadosAnimal.dados[0].somaprojecaocomissao > 0 && <td>{formatoMoeda(dadosAnimal.dados[0].somaprojecaocomissao)}</td>}
                            </tr>
                        </tfoot>
                    </table>

                    {
                        isModalComissaoVendedorOpen && (
                            <ModalComissaoProdutosVendedor onClose={handleCloseModal} dados={dadosComissaoVendedor} top10Produtos={top10ProdutosComissao} />
                        )
                    }
                </div>


                {dadosAnimal.cargo === 'GERENTE_LOJA' && (
                    <div className="font-poppins text-gray-c5 text-center mt-6">
                        <h2 className="font-semibold text-[26px]">Vendedor.com</h2>
                        <div className="overflow-x-auto my-6">
                            <div className="table-wrapper">
                                <table className="table-progresso">
                                    <thead>
                                        <tr>
                                            <th>Realizado</th>
                                            <th>Projetado</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{formatoMoeda(dadosAnimal.dados[0].totalpresentevendedorcom)}</td>
                                            <td>{formatoMoeda(dadosAnimal.dados[0].totalpresentevendedorcom)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    };

    const renderTigreTable = () => {
        return (
            <div className="table-wrapper">
                <table className="table-progresso">
                    <thead>
                        <tr>
                            <th className="coluna-departamento">Departamento</th>
                            <th>Realizado</th>
                            <th>Participação</th>
                            <th>Projetado</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dadosAnimal.dados.map((item, index) => (
                            <tr key={index}>
                                <td className="coluna-departamento">{item.agrupador}</td>
                                <td>{formatoMoeda(item.jurostotais)}</td>
                                <td>{item.participacao.replace('.', ',')}%</td>
                                <td>{formatoMoeda(item.projecao)}</td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td className="coluna-departamento">Total</td>
                            <td>{formatoMoeda(dadosAnimal.dados[0].somatotalpresente)}</td>
                            <td>100%</td>
                            <td>{formatoMoeda(dadosAnimal.dados[0].somaprojecao)}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        );
    };

    const renderPinguimTable = () => {
        return (
            <table className="table-progresso">
                <thead>
                    <tr>
                        <th>Serviço</th>
                        <th>Vendido</th>
                        <th>Projetado</th>
                        {dadosAnimal.dados[0].somaprojecaocomissao > 0 && <th>Projeção Comissão</th>}
                    </tr>
                </thead>
                <tbody>
                    {dadosAnimal.dados.map((item, index) => (
                        <tr key={index}>
                            <td className="department">{item.servico}</td>
                            <td>{formatoMoeda(item.spresente)}</td>
                            <td>{formatoMoeda(item.projecao)}</td>
                            {dadosAnimal.dados[0].somaprojecaocomissao > 0 && <td>{formatoMoeda(item.projecaocomissao)}</td>}
                        </tr>
                    ))}
                </tbody>
                <tfoot>
                    <tr>
                        <td>Total</td>
                        <td>{formatoMoeda(dadosAnimal.dados[0].somatotalpresente)}</td>
                        <td>{formatoMoeda(dadosAnimal.dados[0].somaprojecao)}</td>
                        {dadosAnimal.dados[0].somaprojecaocomissao > 0 && <td>{formatoMoeda(dadosAnimal.dados[0].somaprojecaocomissao)}</td>}
                    </tr>
                </tfoot>
            </table>
        );
    };


    const renderGirafaTable = () => {
        const [mes, ano] = dadosAnimal.mesAno.split('-');

        if (mes == 6 && ano == 2024){
            return (
                <table className="table-progresso">
                    <thead>
                        <tr>
                            <th>Número Filial</th>
                            <th>Filial</th>
                            <th>Realizado</th>
                            <th>Meta</th>
                            <th>Meta</th>
                            <th>Projeção</th>
                            <th>Projeção</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dadosAnimal.dados.map((item, index) => (
                            <tr key={index}>
                                <td>{item.numerofilial}</td>
                                <td className="department">{item.fantasia}</td>
                                <td>{item.realizado}</td>
                                <td>{item.meta}</td>
                                <td>{item.somatotalpresente.replace('.', ',')}%</td>
                                <td>{item.projecao}</td>
                                <td>{item.somaprojecao.replace('.', ',')}%</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            );
        } else {
            return (
                <table className="table-progresso">
                    <thead>
                        <tr>
                            <th>Número Filial</th>
                            <th>Filial</th>
                            <th>Total Propostas</th>
                            <th>Aprovadas</th>
                            <th>Meta</th>
                            <th>Meta</th>
                            <th>Projeção</th>
                            <th>Projeção</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dadosAnimal.dados.map((item, index) => (
                            <tr key={index}>
                                <td>{item.numerofilial}</td>
                                <td className="department">{item.fantasia}</td>
                                <td>{item.total_propostas}</td>
                                <td>{item.aprovadas}</td>
                                <td>{parseInt(item.meta)}</td>
                                <td>{item.somatotalpresente.replace('.', ',')}%</td>
                                <td>{item.projecao}</td>
                                <td>{item.somaprojecao.replace('.', ',')}%</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            );
        }
    };

    const renderHipopotamoTable = () => {
        return (
            <table className="table-progresso">
                <thead>
                    <tr>
                        <th>Número Filial</th>
                        <th>Nome</th>
                        <th>Realizado</th>
                        <th>Meta</th>
                        <th>Meta</th>
                        <th>Projeção</th>
                        <th>Projeção</th>
                    </tr>
                </thead>
                <tbody>
                    {dadosAnimal.dados.map((item, index) => (
                        <tr key={index}>
                            <td>{item.numerofilial}</td>
                            <td className="department">{item.nome}</td>
                            <td>{formatoMoeda(item.realizado)}</td>
                            <td>{formatoMoeda(item.meta)}</td>
                            <td>{item.somatotalpresente.replace('.', ',')}%</td>
                            <td>{formatoMoeda(item.projecao)}</td>
                            <td>{item.somaprojecao.replace('.', ',')}%</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };

    const renderZebraTable = () => {
        return (
            <table className="table-progresso">
                <thead>
                    <tr>
                        <th>Nome</th>
                        <th>Realizado</th>
                        <th>Carteira</th>
                        <th>Carteira(%)</th>
                        <th>Projeção</th>
                        <th>Projeção(%)</th>
                    </tr>
                </thead>
                <tbody>
                    {dadosAnimal.dados.map((item, index) => (
                        <tr key={index}>
                            <td className="department">{item.nome}</td>
                            <td>{formatoMoeda(item.realizado)}</td>
                            <td>{formatoMoeda(item.meta)}</td>
                            <td>{item.somatotalpresente.replace('.', ',')}%</td>
                            <td>{formatoMoeda(item.projecao)}</td>
                            <td>{item.somaprojecao.replace('.', ',')}%</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };

    const renderZebraVelhaTable = () => {
        return (
            <table className="table-progresso">
                <thead>
                    <tr>
                        <th>Nome</th>
                        <th>Realizado</th>
                        <th>Carteira</th>
                        <th>Carteira(%)</th>
                        <th>Projeção</th>
                        <th>Projeção(%)</th>
                    </tr>
                </thead>
                <tbody>
                    {dadosAnimal.dados.map((item, index) => (
                        <tr key={index}>
                            <td className="department">{item.fantasia}</td>
                            <td>{formatoMoeda(item.realizado)}</td>
                            <td>{formatoMoeda(item.meta)}</td>
                            <td>{item.somatotalpresente.replace('.', ',')}%</td>
                            <td>{formatoMoeda(item.projecao)}</td>
                            <td>{item.somaprojecao.replace('.', ',')}%</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };

    const renderVacaLeiteiraTable = () => {
        return (
            <div>
                <table className="table-progresso">
                    <thead>
                        <tr>
                            <th>Departamento</th>
                            <th>Ano Ant</th>
                            <th>Ano Atual</th>
                            <th>Comp. Unid %</th>
                            <th>Ano Ant</th>
                            <th>Ano Atual</th>
                            <th>Comp. R$ %</th>
                            <th>Part.</th>
                            <th>Realizado Margem Verbas</th>
                            <th>Realizado Juros Totais</th>
                            <th>Total Realizado Margem Juros</th>
                            <th>Vaca Leiteira</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dadosAnimal.dados.map((item, index) => (
                            <tr key={index}>
                                <td>{item.agrupador}</td>
                                <td>{item.quantidadepassado}</td>
                                <td>{item.quantidade}</td>
                                <td>{item.quantidadecomparativo.replace('.', ',')}</td>
                                <td>{formatoMoeda(item.totalpresentepassado)}</td>
                                <td>{formatoMoeda(item.totalpresente)}</td>
                                <td>{item.totalpresentecomparativo.replace('.', ',')}</td>
                                <td>{item.margemverbasjurosporc.replace('.', ',')}</td>
                                <td>{formatoMoeda(item.margemverbas)}</td>
                                <td>{formatoMoeda(item.jurostotais)}</td>
                                <td>{formatoMoeda(item.margemverbasjuros)}</td>
                                <td>{item.vacaleiteira.replace('.', ',')}</td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td>Total</td>
                            <td>{dadosAnimal.dados[0].somaquantidadepassado}</td>
                            <td>{dadosAnimal.dados[0].somaquantidade}</td>
                            <td>{dadosAnimal.dados[0].somaquantidadecomparativo.replace('.', ',')}</td>
                            <td>{formatoMoeda(dadosAnimal.dados[0].somatotalpresentepassado)}</td>
                            <td>{formatoMoeda(dadosAnimal.dados[0].somatotalpresente)}</td>
                            <td>{dadosAnimal.dados[0].somatotalpresentecomparativo.replace('.', ',')}</td>
                            <td>{dadosAnimal.dados[0].somamargemverbasjurosporc}</td>
                            <td>{formatoMoeda(dadosAnimal.dados[0].somamargemverbas)}</td>
                            <td>{formatoMoeda(dadosAnimal.dados[0].somajurostotais)}</td>
                            <td>{formatoMoeda(dadosAnimal.dados[0].somamargemverbasjuros)}</td>
                            <td>{dadosAnimal.dados[0].somavacaleiteira.replace('.', ',')}</td>
                        </tr>
                    </tfoot>
                </table></div>
        );
    };

    const renderJaguarTable = () => {
        return (
            <table className="table-progresso">
                <thead>
                    <tr>
                        <th>Número Filial</th>
                        <th>Filial</th>
                        <th>Realizado</th>
                        <th>Meta</th>
                        <th>Meta</th>
                        <th>Projeção</th>
                        <th>Projeção</th>
                    </tr>
                </thead>
                <tbody>
                    {dadosAnimal.dados.map((item, index) => (
                        <tr key={index}>
                            <td>{item.numerofilial}</td>
                            <td className="department">{item.fantasia}</td>
                            <td>{item.somatotalpresente}</td>
                            <td>{item.meta}</td>
                            <td>{item.percentualrealizado.replace('.', ',')}%</td>
                            <td>{item.somaprojecao}</td>
                            <td>{item.percentualprojetado.replace('.', ',')}%</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };

    const renderSuricatoTable = () => {
        return (
            <table className="table-progresso">
                <thead>
                    <tr>
                        <th>Número Filial</th>
                        <th>Filial</th>
                        <th>Realizado</th>
                        <th>Meta</th>
                        <th>Meta</th>
                        <th>Projeção</th>
                        <th>Projeção</th>
                    </tr>
                </thead>
                <tbody>
                    {dadosAnimal.dados.map((item, index) => (
                        <tr key={index}>
                            <td>{item.numerofilial}</td>
                            <td className="department">{item.fantasia}</td>
                            <td>{formatoMoeda(item.somatotalpresente)}</td>
                            <td>{formatoMoeda(item.meta)}</td>
                            <td>{item.percentualrealizado.replace('.', ',')}%</td>
                            <td>{formatoMoeda(item.somaprojecao)}</td>
                            <td>{item.percentualprojetado.replace('.', ',')}%</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };

    const renderRegionalTable = () => {
        return (
            <div className="table-wrapper">
                <table className="table-progresso">
                    <thead>
                        <tr>
                            <th className="coluna-departamento">Filial</th>
                            <th>Pontuação Realizada</th>
                            <th>Pontuação Projetada</th>
                            <th>Meta</th>
                            <th>Realizado</th>
                            <th>Projetado</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dadosAnimal.dados.map((item, index) => (
                            <tr key={index}>
                                <td className="coluna-departamento">{item.fantasia}</td>
                                <td>{item.pontuacaorealizadafilial}</td>
                                <td>{item.pontuacaoprojetadafilial}</td>
                                <td>{formatarValor(item.metafilial)}</td>
                                <td className={getClasseColunaRegional(item.realizadofilial, item.metafilial)}>{formatarValor(item.realizadofilial)}</td>
                                <td className={getClasseColunaRegional(item.projetadofilial, item.metafilial)}>{formatarValor(item.projetadofilial)}</td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td className="coluna-departamento">Total</td>
                            <td>{dadosAnimal.dados[0].pontuacaorealizadatotal}</td>
                            <td>{dadosAnimal.dados[0].pontuacaoprojetadatotal}</td>
                            <td>{formatarValor(dadosAnimal.dados[0].metatotal)}</td>
                            <td className={getClasseColunaRegional(dadosAnimal.dados[0].realizado, dadosAnimal.dados[0].metatotal)}>{formatarValor(dadosAnimal.dados[0].realizado)}</td>
                            <td className={getClasseColunaRegional(dadosAnimal.dados[0].projetado, dadosAnimal.dados[0].metatotal)}>{formatarValor(dadosAnimal.dados[0].projetado)}</td>

                        </tr>
                    </tfoot>
                </table>
            </div>
        );
    };

    if (dadosAnimal.cargo === 'GERENTE_REGIONAL') {
        return (
            <section className="pt-12 bg-white">
                <div className="container">
                    <div className="font-poppins text-gray-c5 text-center">
                        <h2 className="font-semibold text-[26px]">Acompanhe uma visão detalhada do seu progresso em {dadosAnimal.animal}</h2>
                        <p className="font-normal text-lg pt-1">Mês atual ({mesAtual()})</p>
                        <div className="overflow-x-auto my-6">
                            {renderRegionalTable()}
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className="pt-12 bg-white">
            <div className="container">
                <div className="font-poppins text-gray-c5 text-center">
                    <h2 className="font-semibold text-[26px]">Acompanhe uma visão detalhada do seu progresso em {dadosAnimal.animal}</h2>
                    <p className="font-normal text-lg pt-1">Mês atual ({mesAtual()})</p>
                    <div className="overflow-x-auto my-6">
                        {dadosAnimal.idAnimal == 1 && renderLeaoTable()}
                        {dadosAnimal.idAnimal == 2 && renderTigreTable()}
                        {dadosAnimal.idAnimal == 3 && renderPinguimTable()}
                        {dadosAnimal.idAnimal == 4 && renderGirafaTable()}
                        {dadosAnimal.idAnimal == 5 && renderZebraTable()}
                        {dadosAnimal.idAnimal == 8 && renderVacaLeiteiraTable()}
                        {dadosAnimal.idAnimal == 6 && renderHipopotamoTable()}
                        {dadosAnimal.idAnimal == 7 && renderJaguarTable()}
                        {dadosAnimal.idAnimal == 10 && renderSuricatoTable()}
                        {dadosAnimal.idAnimal == 11 && renderZebraVelhaTable()}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DetalheProgressoUsuario